import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import LoadingScreen from '../Common/LoadingScreen'
import Info from '../Common/Info'
import BadgeCard from '../AllBadges/BadgeCard'
import UserRoutes from '../Common/UserRoutes'
import { connect } from 'react-redux'
import { getUser } from '../../store/actions/user'

function User({ user, match, getUser, history }) {
  const userEmail = match.params.user
  const [formObj, setFormObj] = useState({
    state: 'idle',
    email: userEmail,
  })
  const { userBadges, errors } = user
  const { state } = formObj

  // const name = userEmail.split('@')[0].split('.')

  useEffect(() => {
    getUser(formObj, setFormObj)
  }, [getUser])

  const options = { year: 'numeric', month: 'long', day: 'numeric' }

  return (
    <UserRoutes user={userEmail}>
      <div id='User'>
        {state !== 'idle' && <LoadingScreen />}
        <Info messages={[...errors]} alertType='alert-danger' />

        {errors.length === 0 && (
          <>
            <h4 className='ps-2 mb-4 title fw-bold text-center'>Earned Badges</h4>
            <div className='badges-wrapper ps-2'>
              {userBadges.map((element, index) => (
                <BadgeCard
                  onClick={() => {
                    history.push({
                      pathname: `/badge-info/${userEmail}/${element.title}/${element.version}`,
                    })
                  }}
                  key={index}
                  title={`${element.title} - ${element.version}`}
                  createdAt={new Date(element.dateIssued).toLocaleDateString('en-GB', options)}
                  imgLink={element.imageURL}
                  label='Issued on'
                />
              ))}
            </div>
          </>
        )}
      </div>
    </UserRoutes>
  )
}

const mapStateToProps = ({ user }) => ({ user })

export default withRouter(connect(mapStateToProps, { getUser })(User))
